import { render, staticRenderFns } from "./DuplicateButton.vue?vue&type=template&id=6d6152c9&scoped=true&"
import script from "./DuplicateButton.vue?vue&type=script&lang=js&"
export * from "./DuplicateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6152c9",
  null
  
)

export default component.exports